import { TApplicationState } from '../../types/redux';

export function getBanks(state: TApplicationState) {
  const {
    newbuilding: { banks },
  } = state;

  return banks;
}
